import { render, staticRenderFns } from "./powerGridComplexList.vue?vue&type=template&id=323f8808"
import script from "./powerGridComplexList.vue?vue&type=script&lang=js"
export * from "./powerGridComplexList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports